import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import FileSaver from "file-saver";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ShareTokenViewer" })
export default class ShareTokenViewer extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public isDownloading: boolean = false;

    public isGenerating: boolean = false;
    public bundleIndex: number = 0;
    public zip: any = new JSZip();

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly arrayFiles: any[];

    public async downloadZip() {
        this.isDownloading = true;

        const vm = this;
        var promises = [];
        var files = [];
        this.bundleIndex = 0;
        this.isGenerating = true;

        for (var i = 0; i < this.arrayFiles.length; i++) {
            files.push({
                name: this.arrayFiles[i].name
            });

            promises.push(new Promise((resolve, reject) => {
                var file = this.arrayFiles[vm.bundleIndex];
                vm.bundleIndex++;

                JSZipUtils.getBinaryContent(file.fileUrl, function (err, data) {
                    vm.zip.file(file.name, data);
                    resolve(0);
                });
            }));
        }

        await Promise.all(promises);
        this.generateZip();

        GTagHelper.sendEvent("file_download", "filesharing_share", "bundle");

        this.isDownloading = false;
    }

    public generateZip() {
        const vm = this;

        this.zip.generateAsync({ type: "blob" }).then(function (content) {
            FileSaver.saveAs(content, "BremboParts-FileSharing.zip");

            vm.isGenerating = false;
        });
    }
}